var _defs, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcAndroidColored(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32.42 38.15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#61be7e;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_android_colored") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.67,18H35.26V34.91s-.31,1.51-1.51,1.51H31.46v5.44a2.3,2.3,0,0,1-4.59,0V36.58H23.1V42a2.08,2.08,0,0,1-2.36,2,2.18,2.18,0,0,1-2.2-2.2V36.48H16.3a1.52,1.52,0,0,1-1.63-1.63Z",
    transform: "translate(-8.7 -6)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36.63,20.2A2.18,2.18,0,0,1,38.86,18a2.07,2.07,0,0,1,2.25,2.24v9.73A1.89,1.89,0,0,1,39,32c-2.32,0-2.38-1.53-2.38-2.19Z",
    transform: "translate(-8.7 -6)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.7,20.2A2.18,2.18,0,0,1,10.93,18a2.07,2.07,0,0,1,2.25,2.24v9.73a1.89,1.89,0,0,1-2.1,2.1C8.76,32,8.7,30.51,8.7,29.85Z",
    transform: "translate(-8.7 -6)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30,9.23,31.73,6.6c.3-.43-.08-.53-.08-.53-.25-.2-.45.15-.45.15L29.36,9a11.85,11.85,0,0,0-8.69,0c-.56-.8-2-2.86-2.1-2.92s-.3.08-.3.08c-.32.25-.17.37-.17.37L20,9.25a9.24,9.24,0,0,0-5.33,7.14H35.26A9.21,9.21,0,0,0,30,9.23Zm-9.37,4.4a1.15,1.15,0,1,1,1.15-1.15A1.16,1.16,0,0,1,20.58,13.63Zm8.82,0a1.15,1.15,0,1,1,1.15-1.15A1.16,1.16,0,0,1,29.4,13.63Z",
    transform: "translate(-8.7 -6)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAndroidColored);
export default __webpack_public_path__ + "static/media/ic_android_colored.dcb629265c2340f888f35b20da8cf312.svg";
export { ForwardRef as ReactComponent };